import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { BiContainer } from './BiContainer/BiContainer';
import { BiContext, useBiContextGetter } from './BiContext';
function useModalViewEvent(biName, biData) {
    const getBiContext = useBiContextGetter();
    const hasSentModalViewState = useRef(null);
    useEffect(()=>{
        const context = getBiContext();
        if (context && biName && !hasSentModalViewState.current) {
            hasSentModalViewState.current = 'open';
            context.logBiModalView({
                modalName: biName,
                data: biData,
                modal_state: 'open'
            });
        }
        return ()=>{
            if (context && biName && hasSentModalViewState.current === 'open') {
                hasSentModalViewState.current = 'close';
                context.logBiModalView({
                    modalName: biName,
                    data: biData,
                    modal_state: 'close'
                });
            }
        };
    }, [
        getBiContext,
        biName,
        biData
    ]);
}
function BiModalContainerInner(param) {
    let { children, biName, biData } = param;
    // Send modal_view event using the (possibly bridged) parent context
    useModalViewEvent(biName, biData);
    // Use BiContainer to handle hierarchy and data enrichment
    return /*#__PURE__*/ _jsx(BiContainer, {
        name: biName,
        data: biData,
        children: children
    });
}
export function BiModalContainer(param) {
    let { children, biName, biData, biCallerContext } = param;
    const getBiContext = useBiContextGetter();
    if (biCallerContext) {
        return /*#__PURE__*/ _jsx(BiContext.Provider, {
            value: biCallerContext,
            children: /*#__PURE__*/ _jsx(BiModalContainerInner, {
                biName: biName,
                biData: biData,
                children: children
            })
        });
    }
    // No bridging needed, just use the existing context
    if (getBiContext()) {
        return /*#__PURE__*/ _jsx(BiModalContainerInner, {
            biName: biName,
            biData: biData,
            children: children
        });
    }
    // No context at all, just render children
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
